




































































import Vue from 'vue'
import Component from 'vue-class-component'
import axios from 'axios'
import { IContentItem } from '../types'

// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

@Component({
  props: {
    item: Object
  }
})
export default class ContentItemForm extends Vue {

  item!: IContentItem

  mode: 'read' | 'edit' = 'read'

  editor = ClassicEditor

  file?: File

  editorConfig = {
    toolbar: [
      'heading', '|', 'bold', 'italic', 'blockQuote',' |',
      'indent', 'outdent', '|',
      'numberedList', 'bulletedList', 'link', '|',
      'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells','|',
      'undo', 'redo'
    ]
  }

  requiredField = (val: any) => !!val || 'Value is required'

  contentTypes = [{
    label: 'Text',
    value: 'text'
  }, {
    label: 'Video',
    value: 'video'
  }, {
    label: 'File',
    value: 'file'
  }]

  upload(file: File) {
    this.file = file
  }

  async saveFile() {
    if (this.mode === 'edit') {
      if (this.file) {
        this.$emit('loading', true)
        let formData = new FormData()
        switch (this.item.itemType) {
          case 'file':
              formData.append('file', this.file)
            try {
              this.item.filePath = (await axios.post('files/documents', formData, { headers: { 'Content-Type': 'multipart-form-data' } })).data.path
            } catch (error) {
              this.$store.dispatch('showError', 'Failed to upload file')
            }
            break
          case 'video':
            formData.append('file', this.file)
            try {
              this.item.filePath = (await axios.post('files/videos', formData, { headers: { 'Content-Type': 'multipart-form-data' } })).data.path
            } catch (error) {
              this.$store.dispatch('showError', 'Failed to upload file')
            }
            break
        }
        this.$emit('loading', false)
      }
      this.mode = 'read'
    } else {
      this.mode = 'edit'
    }
  }

  moveItem(direction: 'up' | 'down') {
    this.$emit('move', { item: this.item, direction })
  }

  removeItem() {
    this.$emit('remove', this.item)
  }

  filePath(name: string, type: 'file' | 'video' = 'file') {
    let route = type === 'video' ? 'videos' : 'documents'
    return `${process.env.VUE_APP_API_URL}/files/${route}/${name}`
  }

  fileType(item: IContentItem) {
    if (!item.filePath) return
    const fileParts = item.filePath.split('.')
    fileParts.shift()
    const extension = fileParts.join('.')

    switch (extension) {
      case 'jpeg':
      case 'png':
      case 'jpg':
        return 'image'

      case 'mp4':
      case 'ogg':
        return 'video'
    }
    return 'unknown'
  }
}
